<template>
  <div class="columns is-multiline">
    <div class="column is-3" v-for="receipt in receipts">
      <figure class="image is-autoby200">
        <img v-document="receipt.document">
      </figure>
      <div class="columns receipt_footer">
        <div class="column">
          <div class="box-footer">
            <span class="button is-danger is-pulled-left" @click="deleteReceipt(receipt.id)">Verwijderen</span>
            <router-link class="button is-primary is-pulled-right" :to="{ name: 'receipts.edit.processing', params: { id: receipt.id } }" exact>Invoeren</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-padding-fix column is-5" v-if="receipts.length <= 0">
      <article class="message is-info">
        <div class="message-header">
          <p>Geen bonnen gevonden</p>
        </div>
        <div class="message-body">
          Upload een nieuwe bon via de scanner.
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({
      receipts: 'incompleteReceipts'
    })
  },
  async created () {
    await this.$store.dispatch('getIncompleteReceipts')

    this.receipts.sort(function (a, b) {
      return moment(a.createdAt).format('X') - moment(b.createdAt).format('X')
    })
  },
  methods: {
    async deleteReceipt (id) {
      await this.$store.dispatch('deleteReceipt', id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/processing.vue